import { lazy } from 'react';

// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// Crear Cajas User
const NewCajasUser = Loadable(lazy(() => import('views/user/ContabilidadView/CajasView/NewCajasView')));

// List Cajas User
const ListCajasUser = Loadable(lazy(() => import('views/user/ContabilidadView/CajasView/ListCajasView')));

// Crear Bancos User
const NewBancosUser = Loadable(lazy(() => import('views/user/ContabilidadView/BancosView/NewBancosView')));

// List Bancos User
const ListBancosUser = Loadable(lazy(() => import('views/user/ContabilidadView/BancosView/ListBancosView')));

// Crear Tipo_movimiento_caja User
const NewTipoMovimientoCajaUser = Loadable(lazy(() => import('views/user/ContabilidadView/TipoMovimientoCajaView/NewTipoMovimientoCajaView')));

// List Tipo_movimiento_caja User
const ListTipoMovimientoCajaUser = Loadable(lazy(() => import('views/user/ContabilidadView/TipoMovimientoCajaView/ListTipoMovimientoCajaView')));

// Crear TipoMovimientoBancos User
const NewTipoMovimientoBancosUser = Loadable(lazy(() => import('views/user/ContabilidadView/TipoMovimientoBancosView/NewTipoMovimientoBancosView')));

// List TipoMovimientoBancos User
const ListTipoMovimientoBancosUser = Loadable(lazy(() => import('views/user/ContabilidadView/TipoMovimientoBancosView/ListTipoMovimientoBancosView')));

// Crear MovimientosCaja User
const NewMovimientosCajaUser = Loadable(lazy(() => import('views/user/ContabilidadView/MovimientosCajaView/NewMovimientosCajaView')));

// List MovimientosCaja User
const ListMovimientosCajaUser = Loadable(lazy(() => import('views/user/ContabilidadView/MovimientosCajaView/ListMovimientosCajaView')));

// Libro Diario User
const ListLibroDiarioUser = Loadable(lazy(() => import('views/user/ContabilidadView/LibroDiarioView/ListLibroDiarioView')));

// New Diario User
const NewLibroDiarioUser = Loadable(lazy(() => import('views/user/ContabilidadView/LibroDiarioView/NewLibroDiario')));
const ListAsientosManualesUser = Loadable(lazy(() => import('views/user/ContabilidadView/LibroDiarioView/ListAsientosManualesView')));

// Crear MovimientosBancos User
const NewMovimientosBancosUser = Loadable(lazy(() => import('views/user/ContabilidadView/MovimientosBancosView/NewMovimientosBancosView')));

// List MovimientosBancos User
const ListMovimientosBancosUser = Loadable(lazy(() => import('views/user/ContabilidadView/MovimientosBancosView/ListMovimientosBancosView')));

// Crear ConfigContable User
const NewConfigContableUser = Loadable(lazy(() => import('views/user/Taxes/NewConfigContableView')));

// List ConfigContable User
const ListConfigContableUser = Loadable(lazy(() => import('views/user/Taxes/ListConfigContableView')));

// Crear ImpuestosPersonalizados User
const NewImpuestosPersonalizadosUser = Loadable(lazy(() => import('views/user/ContabilidadView/ImpuestosPersonalizadosView/NewImpuestosPersonalizadosView')));

// List ImpuestosPersonalizados User
const ListImpuestosPersonalizadosUser = Loadable(lazy(() => import('views/user/ContabilidadView/ImpuestosPersonalizadosView/ListImpuestosPersonalizadosView')));

// Facturacion Electronica User
const FacturacionElectronicaUser = Loadable(lazy(() => import('views/user/FacturacionView/FacturacionElectronicaView')));

// Facturacion Electronica User
const MayorizacionUserView = Loadable(lazy(() => import('views/user/ContabilidadView/MayorizacionView/ListMayorizacionView')));

// Cuentas Pagar Proveedores User
const ListCuentasPagarProveedoresView = Loadable(lazy(() => import('views/user/ContabilidadView/CuentasPagarProveedoresView/ListCuentasPagarProveedoresView')));

// Cuentas Por Pagar Cartera
const ListCuentasPorPagarCartera = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/CuentasPorPagarView/ListCuentasPorPagarView')));

// Detalle Cuentas Por Pagar Cartera
const DetalleCuentasPorPagarCartera = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/CuentasPorPagarView/DetalleCuentasPorPagarView')));

// Configuración impresión cheque
const ConfiguracionImpresionChequeView = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/ConfiguracionImpresionChequeView')));

// Cuentas por cobrar Clientes
const ListCuentasPorCobrarClientes = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/CuentasPorCobrarView/ListCuentasPorCobrarView')));
const ListaCobrosClientesView = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/CuentasPorCobrarView/ListaCobrosView')));

// Depositos
const DepositosClientes = Loadable(lazy(() => import('views/user/ContabilidadView/DepositosView')));
const ListaDepositos = Loadable(lazy(() => import('views/user/ContabilidadView/ListaDepositosView')));

// Nuevo Activo
const NuevoActivoFijoView  = Loadable(lazy(() => import('views/user/ContabilidadView/ActivosView/NewActivosView')));

// Lista Activos
const ListaActivoFijoView = Loadable(lazy(() => import('views/user/ContabilidadView/ActivosView/ListActivosView')));

// Depreciacion Activos
const DepreciacionActivoFijoView = Loadable(lazy(() => import('views/user/ContabilidadView/ActivosView/DepreciacionActivosView')));

// List Nota Credito
const ListNotaCreditoView = Loadable(lazy(() => import('views/user/ContabilidadView/NotasCreditoView/ListNotaCreditoView')));

// Editar inventario activo fijo
const InventarioActivoFijoView = Loadable(lazy(() => import('views/user/ContabilidadView/ActivosView/InventarioActivosView')));

// Lista Depreciaciones inventario activo fijo
const ListDepreciacionesInventarioPeriodoView = Loadable(lazy(() => import('views/user/ContabilidadView/ActivosView/Components/ListDepreciacionesPeriodoView')));

// Lista Activos Far Pro
const ListaActivosFijosFarProView  = Loadable(lazy(() => import('views/user/ContabilidadView/ActivosView/NewActivosView/ListActivosCatalogoView')));

// Nuevo Empleado
const NuevoEmpleadosView  = Loadable(lazy(() => import('views/user/Empleados/NewEmpleadosView')));

// Lista Empleados
const ListaEmpleadosView  = Loadable(lazy(() => import('views/user/Empleados/ListEmpleadosView')));

// Edit Empleado
const EditEmpleadosView  = Loadable(lazy(() => import('views/user/Empleados/EditEmpleadosView')));

// Nuevo Tipo Egreso Ingreso Empleados
const NuevoTipoEgresosIngresosEmpleadosView  = Loadable(lazy(() => import('views/user/Empleados/RolesEmpleados/RolTiposEgresosIngresosEmpleadosView/NewRolTiposEgresosIngresosView')));

// Lista Tipos Egresos Ingresos
const ListaTiposIngresosEgresosView  = Loadable(lazy(() => import('views/user/Empleados/RolesEmpleados/ListRolTiposEgresosIngresosEmpleadosView')));

// Nuevo Egreso - Ingreso Empleados
const NuevoEgresosIngresosEmpleadosView  = Loadable(lazy(() => import('views/user/Empleados/RolesEmpleados/RolIngresosEsgresosEmpleadosView/NewRolEgresosView')));

// Lista Crear Rol de Pagos
const ListaCrearRolDePagosView  = Loadable(lazy(() => import('views/user/Empleados/RolesEmpleados/RolDePagosView')));

// Carga consolidada de ingresos y egresos del rol
const RolIngresosEgresosConsolidadoView  = Loadable(lazy(() => import('views/user/Empleados/RolesEmpleados/RolIngresosEgresosConsolidadoView')));

// Crear Tarjetas User
const NewTarjetasUser = Loadable(lazy(() => import('views/user/ContabilidadView/TarjetasView/NewTarjetasView')));

// Lista Tarjetas de credito o debito
const ListaTarjetasView  = Loadable(lazy(() => import('views/user/ContabilidadView/TarjetasView/ListTarjetasView')));

// Crear Lista Bancos Cuentas por cobrar
const NewListaBancosUser = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/ListaBancosView/NewListaBancosView')));

// Lista Bancos y tarjetas
const ListaBancosTarjetasView  = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/ListaBancosView/ListListaBancosView')));

// Conciliacion Bancaria
const ConciliacionBancariaView  = Loadable(lazy(() => import('views/user/ContabilidadView/ConciliacionBancariaView')));

// Ats
const AtsView = Loadable(lazy(() => import('views/user/ContabilidadView/AtsView')));

// Cruce comprobantes SRI
const CruceComprobantesView = Loadable(lazy(() => import('views/user/ContabilidadView/CruceComprobantesView')));
const CruceComprobantesDetalleView = Loadable(lazy(() => import('views/user/ContabilidadView/CruceComprobantesView/CruceDetalle')));

// Anulaciones
const ListAnulacionesView = Loadable(lazy(() => import('views/user/ContabilidadView/ListAnulacionesView')));

// Lista Egresos
const ListEgresosCuentasPagadasView = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/CuentasPorPagarView/ListCuentasPorPagarView/ListaEgresos')));

// Depositos Ventas que se validaran
const DepositosValidarVentas = Loadable(lazy(() => import('views/user/ContabilidadView/DepositosValidarVentasView')));
const LiquidacionTarjetasCreditoView = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/LiquidacionTarjetasCreditoView')));
const NuevoEgresoDirectoView = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/NuevoEgresoDirectoView')));
const CruceNotasCreditoView = Loadable(lazy(() => import('views/user/ContabilidadView/Cartera/CruceNotasCreditoView')));
const CierreEjercicioView = Loadable(lazy(() => import('views/user/ContabilidadView/CierreEjercicioView')));
const CierrePeriodosView = Loadable(lazy(() => import('views/user/ContabilidadView/CierrePeriodosView')));

const ContabilidadRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/new-cajas/:id_cajas',
            element: <NewCajasUser />
        },
        {
            path: '/user/list-cajas-view',
            element: <ListCajasUser />
        },
        {
            path: '/user/new-bancos/:id_bancos',
            element: <NewBancosUser />
        },
        {
            path: '/user/list-bancos-view',
            element: <ListBancosUser />
        },
        {
            path: '/user/new-tipo-movimiento-caja/:id_tipo_movimiento_caja',
            element: <NewTipoMovimientoCajaUser />
        },
        {
            path: '/user/list-tipo-movimiento-caja-view',
            element: <ListTipoMovimientoCajaUser />
        },
        {
            path: '/user/new-tipo-movimiento-bancos/:id_tipo_movimiento_bancos',
            element: <NewTipoMovimientoBancosUser />
        },
        {
            path: '/user/list-tipo-movimiento-bancos-view',
            element: <ListTipoMovimientoBancosUser />
        },
        {
            path: '/user/new-movimientos-caja/:id_movimientos_caja',
            element: <NewMovimientosCajaUser />
        },
        {
            path: '/user/list-movimientos-caja-view',
            element: <ListMovimientosCajaUser />
        },
        {
            path: '/user/libro-diario',
            element: <ListLibroDiarioUser />
        },
        {
            path: '/user/new-libro-diario',
            element: <NewLibroDiarioUser />
        },
        {
            path: '/user/list-asientos-manuales-view',
            element: <ListAsientosManualesUser />
        },
        {
            path: '/user/new-movimientos-bancos/:id_movimientos_bancos',
            element: <NewMovimientosBancosUser />
        },
        {
            path: '/user/list-movimientos-bancos-view',
            element: <ListMovimientosBancosUser />
        },
        {
            path: '/user/new-config-contable/:id_cuentas_config',
            element: <NewConfigContableUser />
        },
        {
            path: '/user/list-config-contable-view',
            element: <ListConfigContableUser />
        },
        {
            path: '/user/new-impuestos-personalizados/:id_impuestos_personalizados',
            element: <NewImpuestosPersonalizadosUser />
        },
        {
            path: '/user/list-impuestos-personalizados',
            element: <ListImpuestosPersonalizadosUser />
        },
        {
            path: '/user/facturacion-electronica',
            element: <FacturacionElectronicaUser />
        },
        {
            path: '/user/mayorizacion-view',
            element: <MayorizacionUserView />
        },
        {
            path: '/user/cuentas-pagar-proveedores-view',
            element: <ListCuentasPagarProveedoresView />
        },
        {
            path: '/user/cartera-cuentas-pagar-view',
            element: <ListCuentasPorPagarCartera />
        },
        {
            path: '/user/detalle-cuentas-pagar-cartera-view',
            element: <DetalleCuentasPorPagarCartera />
        },
        {
            path: '/user/config-impresion-cheque-view',
            element: <ConfiguracionImpresionChequeView />
        },
        {
            path: '/user/cuentas-cobrar-clientes-cartera-view',
            element: <ListCuentasPorCobrarClientes />
        },
        {
            path: '/user/lista-cobros-clientes-view',
            element: <ListaCobrosClientesView />
        },
        {
            path: '/user/depositos-clientes-view',
            element: <DepositosClientes />
        },
        {
            path: '/user/lista-depositos-view',
            element: <ListaDepositos />
        },
        {
            path: '/user/nuevo-activo-fijo/:id_activo_fijo_farpro',
            element: <NuevoActivoFijoView />
        },
        {
            path: '/user/lista-activo-fijo',
            element: <ListaActivoFijoView/>
        },
        {
            path: '/user/depreciacion-activo-fijo',
            element: <DepreciacionActivoFijoView/>
        },
        {
            path: '/user/list-nota-credito',
            element: <ListNotaCreditoView/>
        },
        {
            path: '/user/inventario-activo-fijo/:id_inventario_activos',
            element: <InventarioActivoFijoView/>
        },
        {
            path: '/user/list-depreciaciones-periodo/:id_inventario_activos',
            element: <ListDepreciacionesInventarioPeriodoView/>
        },
        {
            path: '/user/list-activos-fijos-catalogo',
            element: <ListaActivosFijosFarProView/>
        },
        {
            path: '/user/nuevo-empleado/:id_empleados',
            element: <NuevoEmpleadosView/>
        },
        {
            path: '/user/list-empleados',
            element: <ListaEmpleadosView/>
        },
        {
            path: '/user/edit-empleado/:id_empleados',
            element: <EditEmpleadosView/>
        },        
        {
            path: '/user/nuevo-tipo-egreso-empleado/:id_rol_tipos_egresos_empleados',
            element: <NuevoTipoEgresosIngresosEmpleadosView/>
        },
        {
            path: '/user/list-rol-egresos-empleados',
            element: <ListaTiposIngresosEgresosView/>
        },
        {
            path: '/user/nuevo-egreso-ingreso-empleados/:id_rol_egresos_empleados',
            element: <NuevoEgresosIngresosEmpleadosView/>
        },
        {
            path: '/user/list-rol-de-pagos',
            element: <ListaCrearRolDePagosView/>
        },
        {
            path: '/user/rol-ingresos-egresos-consolidado',
            element: <RolIngresosEgresosConsolidadoView/>
        },
        {
            path: '/user/new-tarjetas/:id_bancos',
            element: <NewTarjetasUser />
        },
        {
            path: '/user/list-tarjetas',
            element: <ListaTarjetasView />
        },
        {
            path: '/user/new-lista-bancos/:id_lista_bancos',
            element: <NewListaBancosUser />
        },
        {
            path: '/user/list-lista-bancos-tarjetas',
            element: <ListaBancosTarjetasView />
        },
        {
            path: '/user/conciliacion-bancaria',
            element: <ConciliacionBancariaView />
        },                
        {
            path: '/user/ats-view',
            element: <AtsView />
        },
        {
            path: '/user/cruce-comprobantes',
            element: <CruceComprobantesView />
        },
        {
            path: '/user/cruce-comprobantes/:tipo',
            element: <CruceComprobantesDetalleView />
        },
        {
            path: '/user/list-anulaciones-view',
            element: <ListAnulacionesView />
        },                        
        {
            path: '/user/list-egresos-view',
            element: <ListEgresosCuentasPagadasView />
        },                               
        {
            path: '/user/depositos-validar-ventas-view',
            element: <DepositosValidarVentas />
        },
        {
            path: '/user/liquidacion-tarjetas-credito-view',
            element: <LiquidacionTarjetasCreditoView />
        },
        {
            path: '/user/nuevo-egreso-directo',
            element: <NuevoEgresoDirectoView />
        },
        {
            path: '/user/cruce-notas-credito',
            element: <CruceNotasCreditoView />
        },
        {
            path: '/user/cierre-ejercicio',
            element: <CierreEjercicioView />
        },
        {
            path: '/user/cierre-periodos',
            element: <CierrePeriodosView />
        },
    ]
};

export default ContabilidadRoutes;